import { IStyle, mergeStyleSets } from "@fluentui/react";

// Color tokens
const ColorTokens = {
  background: "#FFFFFF",
  foreground: "hsl(222.2, 84%, 4.9%)",
  primary: "hsl(214, 100%, 56%)",
  supportBlue: "hsl(214, 100%, 56%)",
  supportBlueLight: "hsl(213, 100%, 94%)",
  mutedForeground: "hsl(220, 8.9%, 46.1%)",
  border: "hsl(212, 90%, 88%)",
  gradientSupport: "linear-gradient(135deg, hsl(214, 100%, 56%), hsl(213, 89%, 64%))",
  gradientCard: "linear-gradient(135deg, hsl(0, 0%, 100%), hsl(213, 50%, 98%))",
  gradientBg: "#FFFFFF"
};

export const SupportReportsStyles = mergeStyleSets({
  headerContainer: {
    maxWidth: "100%",
    margin: "0 auto",
    paddingBottom: "5px"
  } as IStyle,
  header: {
    borderBottom: `1px solid ${ColorTokens.border}`,
    // borderBottom: `none`,
    background: "transparent",
    backdropFilter: "blur(8px)",
    position: "relative",
    zIndex: 100
  } as IStyle,
  headerContent: {
    textAlign: "center"
  } as IStyle,
  badge: {
    marginBottom: "5px",
    backgroundColor: ColorTokens.supportBlueLight,
    color: ColorTokens.supportBlue,
    padding: "4px 15px",
    borderRadius: "16px",
    fontSize: "14px",
    fontWeight: "500",
    display: "inline-block"
  } as IStyle,
  mainTitle: {
    marginBottom: "16px",
    fontSize: "36px",
    fontWeight: "bold",
    color: ColorTokens.foreground
  } as IStyle,
  mainDescription: {
    margin: "0 auto",
    maxWidth: "1000px",
    fontSize: "18px",
    color: ColorTokens.mutedForeground
  } as IStyle,
  responsiveGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "32px",
    justifyContent: "center",
    width: "auto",
    maxWidth: "1800px",
    margin: "0 auto"
  } as IStyle,
  supportOptionsContainer: {
    position: "relative",
    zIndex: 100,
    maxWidth: "100%",
    padding: "64px 48px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  } as IStyle,
  supportCard: {
    overflow: "hidden",
    border: "1px solid hsl(212, 80%, 85%, 0.2)",
    background: ColorTokens.gradientCard,
    borderRadius: "8px",
    transition: "all 0.3s ease",
    position: "relative",
    zIndex: 200,
    paddingBottom: "20px",
    height: "120px",
    width: "350px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
  } as IStyle,
  supportCardTitle: {
    marginBottom: "5px",
    color: ColorTokens.foreground,
    margin: "0",
    fontSize: "20px",
    fontWeight: "600"
  } as IStyle,
  supportReportCardContent: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    height: "100%"
  } as IStyle,
  supportReportCardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px"
  } as IStyle,
  supportReportCardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #ff6b6b, #4ecdc4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px"
  } as IStyle,
  viewReportRow: {
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
    color: "#0078d4",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer"
  } as IStyle
});
